import React from "react";
import { Loader2 } from "lucide-react";

export function Spinner({ className = "" }) {
  return <Loader2 className={`animate-spin ${className}`} />;
}

export function PageLoader({ label = "Loading..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-slate-500" data-testid="page-loader">
      <Loader2 className="animate-spin h-8 w-8 text-indigo-700 mb-3" />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="empty-state">
      {Icon && <div className="h-14 w-14 rounded-2xl bg-slate-100 flex items-center justify-center mb-4"><Icon className="h-7 w-7 text-slate-400" /></div>}
      <h3 className="font-display font-semibold text-slate-800 text-lg">{title}</h3>
      {hint && <p className="text-sm text-slate-500 mt-1 max-w-sm">{hint}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, tone = "indigo", testid }) {
  const tones = {
    indigo: "bg-indigo-50 text-indigo-700",
    jade: "bg-teal-50 text-teal-700",
    amber: "bg-amber-50 text-amber-700",
    crimson: "bg-red-50 text-red-700",
    violet: "bg-violet-50 text-violet-700",
    slate: "bg-slate-100 text-slate-700",
  };
  return (
    <div className="rt-stat bg-white rounded-xl border border-slate-200 p-4 card-hover" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-wide font-semibold text-slate-500">{label}</p>
          <p className="text-2xl font-display font-extrabold text-slate-900 mt-1">{value}</p>
        </div>
        {Icon && <div className={`h-11 w-11 rounded-xl flex items-center justify-center ${tones[tone]}`}><Icon className="h-5 w-5" /></div>}
      </div>
    </div>
  );
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
      <div>
        <h1 className="rt-page-title font-display text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">{title}</h1>
        {subtitle && <p className="rt-page-sub text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Badge({ children, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-100 text-slate-700",
    green: "bg-emerald-100 text-emerald-700",
    amber: "bg-amber-100 text-amber-700",
    red: "bg-red-100 text-red-700",
    indigo: "bg-indigo-100 text-indigo-700",
    violet: "bg-violet-100 text-violet-700",
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${tones[tone] || tones.slate}`}>{children}</span>;
}

export const statusTone = (s) => {
  const map = {
    published: "green", approved: "green", active: "green", success: "green", resolved: "green", answered: "green",
    draft: "slate", pending: "amber", pending_approval: "amber", processing: "amber", queued: "amber", in_progress: "amber", open: "amber",
    rejected: "red", failed: "red", suspended: "red", closed: "slate", expired: "slate",
  };
  return map[s] || "slate";
};
